import { css } from "styled-components";

import { MEDIA_WIDTHS } from "shared/constants";

import { colors } from "./colors";
import { fonts, transitions } from "./styles";

const mediaWidth = (key: keyof typeof MEDIA_WIDTHS, styles: TemplateStringsArray | string) => {
  return css`
    @media (max-width: ${MEDIA_WIDTHS[key] - 1}px) {
      ${styles}
    }
  `;
};

const theme = {
  colors,
  transition: transitions,
  fonts,
  breakpoint: MEDIA_WIDTHS,
  mediaWidth,
};

export default theme;
export type Theme = typeof theme;
export { default as GlobalStyle } from "./globalStyles";
